import { ActionsPlanTypes } from 'legacy/lut/classes/helpers/partner360/usePartnerInfo'

import { Static } from 'core-components/types'
import { Crud } from 'core/types/Crud'

import { IInvestmentSource } from './models'

export const investmentSources: IInvestmentSource[] = [
  { value: ActionsPlanTypes.Opex },
  { value: ActionsPlanTypes.DGF },
  { value: ActionsPlanTypes.MDF },
  { value: 'Alliance Funds' },
]

export const investmentSourcesCrud = new Crud({
  fetcher: new Static(investmentSources),
  keyField: 'value',
  defaultPaging: {
    page: 0,
    pageSize: investmentSources.length,
  },
})
